export function mergePermissions(permissions: any[], isHierarchical = false): number {
    if (!permissions) {
        throw 'Invalid permissions array passed in.';
    }

    if (permissions.length === 0) {
        return 0;
    }

    if (typeof(permissions[0]) === 'number') {
        throw 'Permissions array had an invalid type. Did you forget the PermissionsCategory decorator?';
    }

    if (!isHierarchical) {
        return permissions.reduce((x, y) => x | y.val, 0);
    } else {
        const max = permissions.reduce((x, y) => x.val > y.val ? x : y).val;
        if (typeof max === 'number') {
            let r = 0;
            for (let i = 0; i <= max; i++) {
                r |= 1 << i;
            }
            return r;
        } else {
            return 0;
        }
    }
}

export function splitPermissions<T>(permissionsCategory: new(...args: any[]) => T, permissions: number) {
    const baseClassProps = Object.getOwnPropertyNames(class { });
    const staticProps = Object.getOwnPropertyNames(permissionsCategory).filter(k => !baseClassProps.includes(k));

    return staticProps
        .filter(prop => (permissions & permissionsCategory[prop].val) === permissionsCategory[prop].val)
        .map(prop => permissionsCategory[prop]);
}